import './src/styles/global.css'
export { wrapRootElement } from './src/wrap-with-provider';
import { cleanupPlacidWidget } from './src/utils/placidWidgetSearch';

export const onClientEntry = () => {
    // Suppress React minified errors in production
    if (process.env.NODE_ENV === 'production') {
      const originalConsoleError = console.error;
      console.error = (...args) => {
        if (typeof args[0] === 'string' && args[0].includes('Minified React error')) {
          return; // Suppress React minified errors
        }
        originalConsoleError(...args);
      };
    }

    if (typeof window !== "undefined" && !window.dataLayer) {
      window.dataLayer = [];
    }
};

export const onRouteUpdate = () => {
  if (typeof window === 'undefined') {
    return;
  }

  window.requestAnimationFrame(() => {
    if (!document.getElementById('widgetSearch')) {
      cleanupPlacidWidget();
    }
  });
};